import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Footer } from './Footer';
import { Nav } from './Nav';
import { StatusBar } from './StatusBar';
import { TopTicker } from './TopTicker';

const Main = styled.main`
  min-height: 60vh;
`;

export function Chrome({ children }: { children: ReactNode }) {
  return (
    <>
      <TopTicker />
      <Nav />
      <StatusBar />
      <Main>{children}</Main>
      <Footer />
    </>
  );
}
